(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-threshold-upsells"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.dd-cart-upsell-form');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const originalText = button.textContent;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Adding…';

    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Unable to add this item.');

      status.textContent = 'Added. Updating your cart…';
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
      status.textContent = error.message;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
